import { Maybe, MediaItem } from '.codegen/generatedApi'
import GridContainer from '@feature/GridContainer'
import GridItem from '@feature/GridItem'
import Image from '@feature/Image/Image'
import { Box, ButtonBase } from '@mui/material'
import { ParsedImgMedia } from 'helpers'
import { useState } from 'react'

type ImageGalleryProps = {
  images?: ParsedImgMedia[]
  sticker?: string | null
  stickerImage?: Maybe<MediaItem>
}
const ImageGallery = ({ images, sticker, stickerImage }: ImageGalleryProps) => {
  const [current, setCurrent] = useState(0)

  if (!images) return <></>

  return (
    <Box>
      <Image imageData={images[current]} contain withBorder size={'LARGE'} stickerType={sticker} stickerImage={stickerImage} />

      <GridContainer rowSpacing={2} columnSpacing={2} paddingY={2}>
        {images.map((img, i) => (
          <GridItem key={i} xs={3}>
            <Box width={'100%'} component={ButtonBase} onClick={() => setCurrent(i)}>
              <Image
                imageData={img}
                contain
                withBorder
                sx={{
                  borderStyle: 'solid',
                  ...(current === i
                    ? {
                        borderColor: 'secondary.main',
                      }
                    : {}),
                }}
              />
            </Box>
          </GridItem>
        ))}
      </GridContainer>
    </Box>
  )
}

export default ImageGallery
